import React from 'react';
import BaseForm from "../forms/BaseForm";


export default class FormModal extends React.PureComponent {

    render() {
        return (
            <div className={`modal ${this.props.visible ? 'is-active' : ''}`}>
                <div className="modal-background"/>
                <div className="modal-card">
                    <header className="modal-card-head">
                        <h5 className="title is-size-5 has-text-white-bis">{this.props.title}</h5>
                    </header>
                    <section className="modal-card-body">
                        {this.props.children}
                        <BaseForm
                            inputs={this.props.inputs}
                            disableAutocomplete
                            onSubmit={this.props.onSubmit}
                            onCancel={this.props.onCancel}
                            otherButtons={this.props.otherButtons}
                            reset={this.props.reset || 0}
                        />
                    </section>
                </div>
            </div>
        )
    }

}
